var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg65(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "left arrow / 24 / Outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2908 12.0036L14.8308 8.46361C15.017 8.27625 15.1216 8.0228 15.1216 7.75861C15.1216 7.49442 15.017 7.24097 14.8308 7.05361C14.7378 6.95988 14.6272 6.88549 14.5054 6.83472C14.3835 6.78395 14.2528 6.75781 14.1208 6.75781C13.9888 6.75781 13.8581 6.78395 13.7362 6.83472C13.6144 6.88549 13.5038 6.95988 13.4108 7.05361L9.1708 11.2936C9.07707 11.3866 9.00268 11.4972 8.95191 11.619C8.90114 11.7409 8.875 11.8716 8.875 12.0036C8.875 12.1356 8.90114 12.2663 8.95191 12.3882C9.00268 12.51 9.07707 12.6206 9.1708 12.7136L13.4108 17.0036C13.5042 17.0963 13.6151 17.1696 13.7369 17.2194C13.8587 17.2691 13.9892 17.2944 14.1208 17.2936C14.2524 17.2944 14.3829 17.2691 14.5047 17.2194C14.6265 17.1696 14.7374 17.0963 14.8308 17.0036C15.017 16.8162 15.1216 16.5628 15.1216 16.2986C15.1216 16.0344 15.017 15.781 14.8308 15.5936L11.2908 12.0036Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg65);
export default __webpack_public_path__ + "static/media/svg65.69746634a28affaec6ce15aab60c2592.svg";
export { ForwardRef as ReactComponent };